import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Copy, themeColor, HorizontalRule, Currency } from '@elparking/components'

import { FormattedMessage } from 'react-intl'

import styled from 'styled-components'

const Rate = ({
    rate,
    type,
}) => <Box>
    <Copy fontSize='small' fontWeight='book' fontColor='gray' textAlign='center' padding='0'>
        { rate }
    </Copy>
    { type }
</Box>

Rate.propTypes = {
    rate: PropTypes.node,
    type: PropTypes.node,
}

const Price = ({ qty }) => {
    if (!qty) {
        return '-'
    }

    return qty.amount === 0
        ? <FormattedMessage defaultMessage='Gratis' />
        : <Currency qty={qty} formatOptions={{
            maximumFractionDigits: 10,
            minFractionDigits: 0,
        }} />
}

Price.propTypes = {
    qty: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
}

export const Container = styled(Flex)`
    border: 1px solid ${themeColor('lightGray40')};
`

const TimeUnit = ({unit}) => {
    if (unit === 'h') {
        return <FormattedMessage defaultMessage='hora' />
    }
    if (unit === 'min') {
        return <FormattedMessage defaultMessage='minuto' />
    }
    return unit
}

TimeUnit.propTypes = {
    unit: PropTypes.string,
}

const Rates = ({
    conection,
    power,
    time,
}) => {
    const withPowerPrice = power && power.amount
    const withTimePrice = time && time.amount
    return <Container background='white' alignItems='center' height='64px'>
        <Box width='32%'>
            <Rate
              rate={<Price qty={conection} />}
              type={<Copy fontSize='xxxSmall' fontWeight='medium' fontColor='gray60' textAlign='center' padding='0' transform='uppercase'>
                  <FormattedMessage defaultMessage='Conexión' />
              </Copy>}
            />
        </Box>
        <Box width='2%'>
            <HorizontalRule.vertical background='lightGray40' height='2em' />
        </Box>
        <Box width='32%'>
            <Rate
              rate={<Price qty={power} />}
              type={<Copy fontSize='xxxSmall' fontWeight='medium' fontColor='gray60' transform={!withPowerPrice ? 'uppercase' : 'inherit'} textAlign='center' padding='0'>
                  { withPowerPrice ? power.unit : <FormattedMessage defaultMessage='Potencia' /> }
              </Copy>}
            />
        </Box>
        <Box width='2%'>
            <HorizontalRule.vertical background='lightGray40' height='2em' />
        </Box>
        <Box width='32%'>
            <Rate
              rate={<Price qty={time} />}
              type={<Copy fontSize='xxxSmall' fontWeight='medium' fontColor='gray60' transform={!withTimePrice ? 'uppercase' : 'inherit'} textAlign='center' padding='0'>
                  { withTimePrice ? <TimeUnit unit={time.unit} /> : <FormattedMessage defaultMessage='Tiempo' /> }
              </Copy>}
            />
        </Box>
    </Container>
}

Rates.propTypes = {
    conection: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    power: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
        unit: PropTypes.string,
    }),
    time: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
        unit: PropTypes.string,
    }),
}

Rates.defaultProps = {
    conection: null,
    power: null,
    time: null,
}

export default Rates
